export default class OrganizationAppInvitation {
  constructor(API) {
    this.api = API;
  }
  //Manager
  async createOrganizationAppBulkInvitation(orgID, invitationObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/organization/${orgID}/app/invitations`;
    req.body = { ...invitationObj };
    return await req.exec();
  }
  async resendOrganizationAppInvitation(orgID, invitationID, invitationObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/organization/${orgID}/app/invitation/${invitationID}/resend`;
    req.body = { ...invitationObj };
    return await req.exec();
  }
  async createOrganizationAppInvitation(orgID, invitationObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/organization/${orgID}/app/invitation/new`;
    req.body = { ...invitationObj };
    return await req.exec();
  }
  async deleteOrganizationAppInvitation(orgID, invitationID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/organization/${orgID}/app/invitation/${invitationID}`;
    return await req.exec();
  }
  async getOrganizationAppInvitationByOrgID(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/organization/${orgID}/app/invitations`;
    return await req.exec();
  }
  //Member routes
  async approveOrganizationAppInvitation(orgID, invitationID ) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/organization/${orgID}/app/invitation/${invitationID}/approve`;
    return await req.exec();
  }
  async rejectOrganizationAppInvitation(orgID, invitationID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/organization/${orgID}/app/invitation/${invitationID}/reject`;
    return await req.exec();
  }
  async getMyOrganizationAppInvitation(invitationID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/organization/app/invitations/my/${invitationID}`;
    return await req.exec();
  }
}
